import { Font, StyleSheet } from '@react-pdf/renderer';

Font.register({
  family: 'Lato',
  fonts: [
    { src: '/Lato-Thin.ttf', fontWeight: 100 },
    { src: '/Lato-Light.ttf', fontWeight: 300 },
    { src: '/Lato-Regular.ttf', fontWeight: 400 },
    { src: '/Lato-Bold.ttf', fontWeight: 700 },
    { src: '/Lato-Black.ttf', fontWeight: 900 },
    { src: '/Lato-ThinItalic.ttf', fontWeight: 100, fontStyle: 'italic' },
    {
      src: '/Lato-LightItalic.ttf',
      fontWeight: 300,
      fontStyle: 'italic',
    },
    {
      src: '/Lato-RegularItalic.ttf',
      fontWeight: 400,
      fontStyle: 'italic',
    },
    { src: '/Lato-BoldItalic.ttf', fontWeight: 700, fontStyle: 'italic' },
    {
      src: '/Lato-BlackItalic.ttf',
      fontWeight: 900,
      fontStyle: 'italic',
    },
  ],
});

export const styles = StyleSheet.create({
  page: {
    position: 'relative',
    paddingBottom: 40,
    flexDirection: 'column',
    alignItems: 'center',
  },

  citationWrapper: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    textAlign: 'center',

    height: 'auto',
    width: '100%',
    marginTop: 20,

    paddingTop: 20,
    paddingBottom: 20,
  },
  citationInnerWrapper: {
    maxWidth: 380,
    alignItems: 'center',
    paddingHorizontal: 10,
  },
  citation: {
    color: '#ffffff',
    fontFamily: 'Lato',
    fontSize: 16,
    fontWeight: 900,
    lineHeight: 1.4,
    textAlign: 'center',
  },
  line: {
    width: 89,
    borderTopWidth: 2,
    borderColor: '#ffffff',
    marginTop: 20,
    marginBottom: 20,
  },
  personDetails: {
    color: '#fff',
    fontFamily: 'Lato',
    fontSize: 11,
    fontWeight: 400,
    lineHeight: 1,
    textAlign: 'center',
  },

  contentWrapper: {
    display: 'flex',
    flexDirection: 'row',
    gap: 20,
    width: '100%',
    paddingHorizontal: 40,
    marginTop: 20,
  },

  leftColumn: {
    flex: 1,
  },

  rightColumn: {
    flex: 1,
  },

  title: {
    color: '#27343d',
    fontFamily: 'Lato',
    fontSize: 19,
    fontWeight: 900,
    width: 244.5,
  },

  titleUnderline: {
    width: 89,
    borderTopWidth: 2,
    marginTop: 15,
    marginBottom: 15,
  },

  description: {
    color: '#27343d',
    fontFamily: 'Lato',
    fontWeight: 400,
    fontSize: 11,
    lineHeight: 1.2,
    textAlign: 'left',
    width: 244.5,
  },

  topImage: {
    width: '100%',
    height: 220,
    objectFit: 'cover',
    marginBottom: 10,
    borderRadius: 4,
  },
  middleRow: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginBottom: 10,
  },
  middleImage: {
    width: '48%',
    height: 100,
    objectFit: 'cover',
    borderRadius: 4,
  },
  bottomImage: {
    width: '100%',
    height: 156,
    objectFit: 'cover',
    borderRadius: 4,
  },
});
